import { render, staticRenderFns } from "./AddNotificationRecipient.vue?vue&type=template&id=320b6b3e"
import script from "./AddNotificationRecipient.vue?vue&type=script&lang=ts"
export * from "./AddNotificationRecipient.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports